import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, viewChild } from '@angular/core';
import { OktaWrapperService } from '@mysrc/services/framework';
import { DrawerItem } from '@progress/kendo-angular-layout';
import { Observable, ReplaySubject } from 'rxjs';
import urlJoin from 'url-join';
import { v4 as uuidv4 } from 'uuid';
import { TileService } from '../../../features/widgets/services/tile.service';
import { MenuVerticalComponent } from '../components/menu-vertical/menu-vertical.component';
import { ICurrentUser, IUserSettings, IUserSettingsTab } from '../models';
import { BaseHttpService } from './base-http.service';

@Injectable({
  providedIn: 'root'
})
export class UserService extends BaseHttpService {
  private settingsObject?: IUserSettings;
  private currentSettings: { [key: string]: any; } = {};
  private lastSavedSettings: { [key: string]: any; } = {};
  private attempts: number = 0;
  currentRoles: any[] = [];
  public items: Array<DrawerItem> = []
  jsonData: any[] = [];
  private _settingsTabs: IUserSettingsTab[] = [];

  private _currentUser$: ReplaySubject<ICurrentUser> = new ReplaySubject<ICurrentUser>(1);

  private settingsEndpoint;
  private currentUserEndpoint;
  protected compMenuVertical = viewChild<MenuVerticalComponent>("lhsMenu");
  constructor(http: HttpClient, @Inject('CONFIG_SETTINGS') config: any, private oktaWrapper: OktaWrapperService, private tileService: TileService) {
    super(http, oktaWrapper.oktaAuth);
    const configGeneral = config['general'];
    this.baseUrl = configGeneral['adminApiUrl'];
    this.apiKey = configGeneral['apiKey'];

    const configUser = config['userSettings'];
    this.settingsEndpoint = configUser['settingsEndpoint'];
    this.currentUserEndpoint = configUser['currentUserEndpoint'];

    const storedUser = localStorage.getItem('currentUser');
    if (storedUser) {
      const user: ICurrentUser = JSON.parse(storedUser);
      this._currentUser$.next(user); // Emit the stored user
    }

    this.oktaWrapper.authenticationChanged.subscribe((isAuth: boolean) => {
      if (isAuth) {
        this.load();
      }
    });

    if (this.oktaWrapper.isAuthenticated()) {
      this.load();
    }

  }

  load(): void {
    const token = this.getToken();
    if (token != undefined) {
      this.loadSettings(token);
      this.loadUser(token);
    }
  }

  private loadSettings(token: string) {

    // Retrieve from service

    const url = urlJoin(this.baseUrl, this.settingsEndpoint)
    this.getItem<IUserSettings>(url, this.getHttpBearerHeaders(token))
      .subscribe((prefs: any) => {
        if (prefs != null) {
          this.currentSettings = prefs.settings;
          this.lastSavedSettings = { ...this.currentSettings }; // Clone settings
        }
      });

  }


  async getCurrentRoles(isRefresh: boolean) {
    //return true;
    let items = localStorage.getItem("currentFeatures");
    if (isRefresh) {
      items = null;
    }
    if (items) {
      const features = JSON.parse(items);
      if (features.find((x: any) => x.apiUrl == '/ai') == false) {
        features.add(
          {
            "id": "31039893-0e31-4118-aad7-68cc9a1445a4",
            "name": "AI Hub",
            "description": "AI Hub",
            "apiUrl": "/ai",
            "isActive": true,
          })
      }

      features.forEach((x: any) => {
        this.currentRoles.push(x.apiUrl);
      });
      this.loaditems();
    } else {
      await this.tileService.getMappedUserFeatures().then((features) => {
        features.forEach((feature: any) => {
          this.currentRoles.push(feature.apiUrl);
        })
        localStorage.setItem("currentFeatures", JSON.stringify(features));
        this.loaditems();

      })
    }
  }
  loaditems() {
    var itemstemp: routedDrawerItem[] = [];
    this.jsonData.forEach((data) => {
      if (this.currentRoles.find(c => c.toLowerCase() == data.path.toLowerCase()) && data.showhide == true) {
        if (data.text == 'Smart Bank' && data.showhide == true) {
          itemstemp.push({ id: data.id, icon: 'smartbank-home-icon', text: data.text, path: data.path, hasChildren: data.hasChildren, pId: data.parentId, showHide: data.showhide });
        } else if (data.text == 'Ideaverse') {
          itemstemp.push({ id: data.id, text: data.text, icon: 'ideaverse-home-icon', path: data.path, hasChildren: data.hasChildren, pId: data.parentId, showHide: data.showhide });

        }
        else if (data.text == 'ISGGPT' && data.showhide == true) {
          itemstemp.push({ id: data.id, text: data.text, icon: 'isggpt-home-icon', path: data.path, hasChildren: data.hasChildren, pId: data.parentId, showHide: data.showhide });
        }
        else if (data.text == 'Whiteboard' && data.showhide == true) {
          itemstemp.push({ id: data.id, text: data.text, icon: 'white-home-icon', path: data.path, hasChildren: data.hasChildren, pId: data.parentId, showHide: data.showhide });
        }
        //else if (data.text == 'Market Insights') {
        // // don't push into menu will push it after verifing submenu
        //}
        else {
          itemstemp.push({
            id: data.id, text: data.text, icon: data.icon + ' home-icon', items: data.items, path: data.path, hasChildren: data.hasChildren, pId: data.parentId, showHide: data.showhide
          });
        }
      }


    });


    this.items = itemstemp;
  }


  clearLocalStorage() {
    localStorage.removeItem("currentFeatures");
    localStorage.removeItem("currentUser");
  }
  private loadUser(token: string) {
    const url = urlJoin(this.baseUrl, this.currentUserEndpoint)

    this.getItem<ICurrentUser>(url, this.getHttpBearerHeaders(token))
      .subscribe((user: ICurrentUser) => {
        localStorage.setItem('currentUser', JSON.stringify(user));
        return this._currentUser$.next(user);
      });
  }

  public getSettings(): { [key: string]: any } {
    return this.currentSettings;
  }

  public updateSetting(key: string, val: any) {
    this.currentSettings[key] = val;
  }

  public saveSettingsChanges() {
    this.save();
    this.lastSavedSettings = { ...this.currentSettings };
  }

  public cancelSettingsChanges() {
    this.currentSettings = { ...this.lastSavedSettings };
  }

  public getCurrentUser(): Observable<ICurrentUser> {
    return this._currentUser$.asObservable();
  }


  public get emptyUser(): ICurrentUser {
    return { systemId: '0', firstName: '', lastName: '', initials: '', fullName: '', alias: '', companyName: '' };
  }

  public registerSettingsTabs(items: IUserSettingsTab[]) {
    this._settingsTabs = items;
  }

  public getUserSettingsTabs(): IUserSettingsTab[] {
    return this._settingsTabs;
  }


  private save() {

    const user = this.oktaWrapper.getUser();

    if (user) {

      const token = this.getToken();

      if (this.settingsObject == null) {
        this.settingsObject = {
          id: uuidv4(), userEmail: user.email, settings: {} // CHanged to email from id to fix an update issue. id is now returning integer
        };
      }

      if (token != undefined && this.settingsObject) { // added this.settingsObject check to prevent error when settingsObject is undefined
        this.settingsObject.settings = this.currentSettings;

        const url = urlJoin(this.baseUrl, this.settingsEndpoint)
        //Persist to service
        this.saveItem(this.settingsObject, true, url, this.getHttpBearerHeaders(token))
          .subscribe(
            (err: any) => console.log(err));
      }

    }
  }
}

export interface routedDrawerItem extends DrawerItem {
  id: number;
  path?: string;
  hasChildren?: boolean;
  isExpanded?: boolean;
  tooltip?: string;
  level?: number;
  pId?: number;
  Icon?: string;
  items?: any;
  text: string;
  imageUrl?: string;
  showHide?: boolean;
}



